







import { DateTime } from "luxon";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class SessionDate extends Vue {
    @Prop() beginAt: DateTime;
    @Prop() endAt: DateTime;
    @Prop() showIsLive: boolean;

    get beginDate() {
        return (this.beginAt as DateTime)?.toFormat("T");
    }

    get endDate() {
        return (this.endAt as DateTime)?.toFormat("T");
    }
}
